import React from 'react';
import { useAuth } from './hooks/useAuth';
import App from './App';
import Login from './components/Login/Login';

export default function AppShell() {
    const { user, loading } = useAuth();

    if (loading) {
        return (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', background: '#0f172a', color: '#94a3b8' }}>
                Loading�
            </div>
        );
    }

    return user ? <App /> : <Login />;
}